<template>
  <section
    id="mentor-entry-about"
    class="co-bg-striped"
  >
    <div class="co-container-lg px-4 py-20 text-center">
      <h2 class="co-heading-2">
        <slot name="title">
          タイトル
        </slot>
        <br class="md:hidden">
        メンターについて
      </h2>
      <slot name="content">
        テキストが入ります
      </slot>
    </div>
  </section>
</template>
